// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Somalia from '../_raw/flag/icon_flag_somalia.png';

export default () => <img src={Somalia} alt="Somalia" />;
